( function () {
    'use strict';
    e.newsletterpopup = {};
    e.newsletterpopup.init = function () {
        if ( jQuery( '.js-e-newsletter-popup-container' ).length ) {
            var containerImage = jQuery( '.js-e-newsletter-popup-container' ).find( 'img' ),
                teaserImage = jQuery( '.js-e-newsletter-popup-teaser' ).find( 'img' ),
                imgArr = [];
            imgArr.push( containerImage, teaserImage );
            jQuery.each( imgArr, function ( i, obj ) {
                var img = new Image();
                img.onload = function () {
                    img.width = this.width;
                    img.height = this.height;
                    e.newsletterpopup.check();
                };
                img.src = obj.attr( 'src' );
                obj.after( img ).remove();
            } );
        }
    };
    e.newsletterpopup.check = function () {
        var isMobile = jQuery( 'input[name="e-newsletter-popup-mobile"]' ).val(),
            mQuery = jQuery( window ).width();
        if ( !isMobile && mQuery > 460 ) {
            e.newsletterpopup.cookie.check();
        }
        else if ( isMobile === 'True' ) {
            e.newsletterpopup.cookie.check();
        }
        else {
            return false;
        }
    };
    e.newsletterpopup.build = function () {
        var ePc = jQuery( '.js-e-newsletter-popup-container' ),
            ePci = ePc.find( 'img' ),
            ePt = jQuery( '.js-e-newsletter-popup-teaser' ),
            ePti = ePt.find( 'img' ),
            offset = e.newsletterpopup.mobile.bottom();
        ePc.css( {
            width: ePc.width(),
            bottom: -( jQuery( window ).height() - ePc.height() + ( offset + 100 ) ),
            paddingRight: ePci.width()
        } ).show().addClass( 'closed' );
        ePt.css( {
            bottom: -( jQuery( window ).height() - ePt.height() + offset ),
            paddingRight: ePti.width()
        } ).show().addClass( 'closed' );
        if ( ( jQuery.cookie( 'e-newsletterDisabled' ) !== 'hidden' ) ) {
            var popupTimer = setTimeout( function () {
                ePc.removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', offset );
            }, 10000 );
        }
        setTimeout( function () {
            ePt.removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', offset );
        }, 500 );
        jQuery( '.js-e-newsletter-popup-close' ).bind( 'click', function ( event ) {
            event.preventDefault();
            clearTimeout( popupTimer );
            e.newsletterpopup.hide( -( ePc.height() + ePci.height() ) );
        } );
        jQuery( 'body' ).on( 'click', function ( event ) {
            if ( ePc.hasClass( 'opened' ) ) {
                if ( jQuery( event.target ).parents( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ).length === 0 && !jQuery( event.target ).is( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ) ) {
                    e.newsletterpopup.hide( -( ePc.height() + ePci.height() ) );
                    clearTimeout( popupTimer );
                }
            }
        } );
        jQuery( '.js-e-newsletter-popup-teaser a' ).bind( 'click', function ( event ) {
            event.preventDefault();
            e.newsletterpopup.show( offset );
        } );
        jQuery( '.js-e-newsletter-popup-form-submit' ).bind( 'click', function () {
            e.newsletterpopup.form.validate();
        } );
        ePc.find( 'input' ).bind( 'keyup', function () {
            if ( jQuery( this ).val() ) {
                jQuery( this ).removeClass( 'error' );
            }
        } );
    };
    e.newsletterpopup.show = function ( offset ) {
        jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', offset );
    };
    e.newsletterpopup.hide = function ( height ) {
        jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'opened' ).addClass( 'closed' ).css( 'bottom', height );
        e.newsletterpopup.cookie.disabled( 'hidden' );
    };
    e.newsletterpopup.destroy = function ( offset ) {
        e.newsletterpopup.hide( -offset * 2 );
        setTimeout( function () {
            jQuery( '.js-e-newsletter-popup-container' ).remove();
        }, 500 );
        e.newsletterpopup.cookie.disabled( 'disabled' );
    };
    e.newsletterpopup.success = function ( response ) {
        var height = jQuery( '.js-e-newsletter-popup-container' ).height(),
            delay = jQuery( 'input[name="e-newsletter-popup-removal-delay"]' ).val();
        if ( delay === '' ) {
            delay = 6000;
        }
        else {
            delay = parseInt( delay ) * 1000;
        }
        e.newsletterpopup.form.loading();
        jQuery( '.js-e-newsletter-popup-teaser' ).remove();
        jQuery( '.js-e-newsletter-popup-container' ).css( 'height', height ).find( 'form' ).hide();
        jQuery( '.js-e-newsletter-popup-msg' ).fadeOut( 'fast', function () {
            jQuery( '.js-e-newsletter-comfirm-msg' ).html( response ).fadeIn( 'fast' );
        } );
        jQuery( '.js-e-newsletter-popup-loader' ).remove();
        if ( jQuery( '.js-e-newsletter-popup-container' ).hasClass( 'opened' ) ) {
            setTimeout( function () {
                e.newsletterpopup.destroy( height );
            }, delay );
        }
    };
    e.newsletterpopup.mobile = {};
    e.newsletterpopup.mobile.bottom = function () {
        if ( jQuery( '.e-nav-utilities-bottom' ).css( 'position' ) === 'fixed' ) {
            return jQuery( '.e-nav-utilities-bottom' ).height();
        }
        else {
            return 0;
        }
    };
    e.newsletterpopup.form = {};
    e.newsletterpopup.form.loading = function () {
        var overlay = jQuery( 'js-e-newsletter-popup-loader' );
        jQuery( overlay ).fadeIn( 'fast' );
    };
    e.newsletterpopup.form.validate = function () {
        var jForm = jQuery( '.js-e-newsletter-popup-container' ).find( 'form' ),
            jMethod = jQuery( 'input[name="e-newsletter-popup-method"]' ).val();
        jQuery( jForm ).validate( {
            errorClass: 'text-error',
            errorElement: 'span',
            errorPlacement: function ( error, element ) {
                error.appendTo( element.closest( 'div' ) );
            },
            submitHandler: function () {
                if ( jMethod === 'csv' ) {
                    e.newsletterpopup.form.csv( jForm );
                }
                else if ( jMethod === 'emailmarketing' ) {
                    e.newsletterpopup.form.emailMarketing( jForm );
                }
                else if ( jMethod === 'mailchimp' ) {
                    e.newsletterpopup.form.mailchimp( jForm );
                }
            }
        } );
    };
    e.newsletterpopup.form.mailchimp = function ( jForm ) {
        jQuery.ajax( {
            type: jForm.attr( 'method' ),
            url: jForm.attr( 'action' ).replace( '/post?', '/post-json?' ).concat( '&c=?' ),
            data: jForm.serialize(),
            timeout: 5000,
            cache: false,
            dataType: 'jsonp',
            contentType: 'application/json; charset=utf-8',
            beforeSend: function () {
                e.newsletterpopup.form.loading( jForm );
            },
            success: function ( data ) {
                if ( data.result !== 'success' ) {
                    jQuery( '.js-e-newsletter-popup-loader' ).remove();
                    jQuery( '.js-e-newsletter-comfirm-msg' ).html( '<p>' + data.msg + '</p>' ).fadeIn( 'fast' );
                }
                else {
                    e.newsletterpopup.success( '<p>' + data.msg + '</p>' );
                }
            }
        } );
        return false;
    };
    e.newsletterpopup.form.csv = function ( jForm ) {
        var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
        jQuery.ajax( {
            type: 'POST',
            url: '/Admin/Public/FormMailer.aspx',
            data: jForm.serialize(),
            beforeSend: function () {
                e.newsletterpopup.form.loading( jForm );
            },
            error: function ( err ) {
                console.log( err );
            },
            success: function () {
                e.newsletterpopup.success( response );
            }
        } );
        return false;
    };
    e.newsletterpopup.form.emailMarketing = function ( jForm ) {
        var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
        jQuery.ajax( {
            type: 'POST',
            url: '/',
            data: jForm.serialize(),
            beforeSend: function () {
                e.newsletterpopup.form.loading( jForm );
            },
            success: function () {
                e.newsletterpopup.success( response );
            }
        } );
        return false;
    };
    e.newsletterpopup.cookie = {};
    e.newsletterpopup.cookie.disabled = function ( state ) {
        jQuery.cookie( 'e-newsletterDisabled', state, {
            path: '/',
            expires: 365
        } );
    };
    e.newsletterpopup.cookie.id = function ( id ) {
        jQuery.cookie( 'e-newsletterId', id, {
            path: '/',
            expires: 365
        } );
    };
    e.newsletterpopup.cookie.check = function () {
        var eNewsletterId = jQuery( 'input[name="e-newsletter-popup-id"]' ).val().replace( /\s+/g, '' ).substr( 0, 50 );
        if ( jQuery.cookie( 'e-newsletterDisabled' ) !== 'disabled' ) {
            e.newsletterpopup.build();
            e.newsletterpopup.cookie.id( eNewsletterId );
        }
        else if ( jQuery.cookie( 'e-newsletterId' ) !== eNewsletterId ) {
            e.newsletterpopup.build();
            e.newsletterpopup.cookie.disabled( '' );
            e.newsletterpopup.cookie.id( eNewsletterId );
        }
        else {
            return false;
        }
    };
}() );
